/**
 * Step One Foods — Header JS
 * Mobile nav: left slide-out, hamburger→X morph, stagger, accordion submenu
 */
(function () {
  'use strict';

  var hamburger = document.querySelector('[data-sof-hamburger]');
  var nav = document.getElementById('sof-mobile-nav');
  if (!hamburger || !nav) return;

  var closeBtns = nav.querySelectorAll('[data-sof-mobile-close]');
  var accordion = nav.querySelector('[data-sof-accordion]');
  var sub = nav.querySelector('.sof-mobile-sub');
  var panel = nav.querySelector('.sof-mobile-nav__panel');

  /* ── Open / close ─────────────────────────────────────────── */
  function openNav() {
    nav.removeAttribute('hidden');
    nav.offsetHeight; // Force reflow so CSS transition plays from off-screen
    nav.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.setAttribute('aria-label', 'Close menu');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    nav.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.setAttribute('aria-label', 'Open menu');
    document.body.style.overflow = '';

    // Re-apply hidden after panel slides out
    if (panel) {
      panel.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName === 'transform') {
          nav.setAttribute('hidden', '');
          panel.removeEventListener('transitionend', onEnd);
        }
      });
    } else {
      setTimeout(function () { nav.setAttribute('hidden', ''); }, 400);
    }
  }

  hamburger.addEventListener('click', function () {
    if (nav.classList.contains('is-open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeNav);
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) closeNav();
  });

  /* ── Learn accordion ──────────────────────────────────────── */
  if (accordion && sub) {
    accordion.addEventListener('click', function () {
      var isOpen = accordion.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        accordion.setAttribute('aria-expanded', 'false');
        sub.classList.remove('is-open');
      } else {
        accordion.setAttribute('aria-expanded', 'true');
        sub.classList.add('is-open');
      }
    });
  }

  /* ── Desktop dropdown ─────────────────────────────────────── */
  document.querySelectorAll('[data-sof-dropdown]').forEach(function (wrapper) {
    var trigger = wrapper.querySelector('[data-sof-dropdown-trigger]');
    var menu = wrapper.querySelector('.sof-dropdown__menu');
    if (!trigger || !menu) return;

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!open));
      if (open) { menu.setAttribute('hidden', ''); } else { menu.removeAttribute('hidden'); }
    });

    document.addEventListener('click', function () {
      trigger.setAttribute('aria-expanded', 'false');
      menu.setAttribute('hidden', '');
    });
  });

})();
